import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { PageTitle } from "@/components/PageTitle";
import { RespondentForm } from "@/components/RespondentForm";
import { BackButton } from "@/components/ui/BackButton";
import { RespondentsForDossier } from "@/features/RespondentEditor/queries";
import { useTranslation } from "@/i18n/client";
import { useSessionContext } from "@/session";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/dossier/respondents/$respondentId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("RespondentEditor");
  const { organizationKey, dossierId } = useSessionContext();
  const { data } = useSuspenseQuery(RespondentsForDossier, {
    variables: { organizationKey, dossierId },
  });
  const { respondentId } = Route.useParams();

  const respondent = data.currentDossier.respondents.find(
    (respondent) => respondent.id === respondentId,
  );

  if (!respondent) {
    return <span>404</span>;
  }

  return (
    <>
      <PageTitle title="editRespondent" />
      <Section variant="header">
        <SectionHeader
          header={t(`type`, { context: respondent.type })}
          buttons={<BackButton href="/$organizationKey/$dossierId/dossier" />}
        />
      </Section>

      <Section>
        <RespondentForm respondent={respondent} />
      </Section>
    </>
  );
}
